import React, { useState, useContext, useMemo } from "react";
import {
  FaProjectDiagram,
  FaFileInvoiceDollar,
  FaHandshake,
  FaChartLine,
  FaSearch,
  FaEye,
  FaExclamationTriangle,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import ProjectPostOrderLayoutWrapper from "../components/ProjectPostOrderLayoutWrapper";
import ProjectPerOrderLayoutWrapper from "../components/ProjectPreOrderLayoutWrapper";

const ProjectManagementDashboard = ({ type }) => {
  const [isDark, setIsDark] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const LayoutWrapper =
    type === "preorder"
      ? ProjectPerOrderLayoutWrapper
      : ProjectPostOrderLayoutWrapper;

  const getReportPath = (base) => {
    return type === "preorder"
      ? `/OrderManagement/PreOrder-${base}`
      : `/OrderManagement/PostOrder-${base}`;
  };

  // ==============================
  // localStorage helper
  // ==============================
  const getLS = (key) =>
    typeof window !== "undefined" ? localStorage.getItem(key) || "" : "";

  const finYearId = getLS("finYearId");
  const finYear = getLS("finYear");
  const branchId = getLS("branchId") || getLS("branchid");
  const branchType = getLS("branchType") || getLS("branchtype");
  const userId = getLS("userId") || getLS("loginuserid");

  // common headers
  const commonHeaders = useMemo(
    () => ({
      "x-finyearid": finYearId,
      "x-finyear": finYear,
      "x-branchid": branchId,
      "x-branchtype": branchType,
      "x-userid": userId,
    }),
    [finYearId, finYear, branchId, branchType, userId]
  );

  // ==============================
  // Sample data
  // ==============================
  const estimationAlerts = [
    {
      sno: 1,
      branchName: "HEAD-OFFICE",
      totalEstimation: 60,
      waiting: 30,
      approved: 30,
      totalEstimationCost: "₹40,84,99,637.85",
    },
  ];

  const tenderAlerts = [
    { sno: 1, branchName: "Branch 8", totalTenders: 13, success: 13, unSuccess: 0 },
    { sno: 2, branchName: "HILARA", totalTenders: 11, success: 11, unSuccess: 0 },
    { sno: 3, branchName: "TUMTIKAWN", totalTenders: 1, success: 1, unSuccess: 0 },
    { sno: 4, branchName: "H/O 1", totalTenders: 1, success: 1, unSuccess: 0 },
    { sno: 5, branchName: "NISSI HO", totalTenders: 3, success: 3, unSuccess: 0 },
  ];

  const projectAlerts = [
    {
      sno: 1,
      branchName: "Branch 8",
      projectName: "A PROJECTS WORK",
      estimationValue: "₹3,80,700.00",
      currentExpenses: "₹32,76.0000",
      status: "Normal",
    },
    {
      sno: 2,
      branchName: "Branch 8",
      projectName: "road test",
      estimationValue: "₹1,54,378.00",
      currentExpenses: "₹60.0000",
      status: "Normal",
    },
    {
      sno: 3,
      branchName: "Branch 8",
      projectName: "TESTING ENTRY FOR Returnable item",
      estimationValue: "₹1,00,00.00",
      currentExpenses: "₹1,50,00.0000",
      status: "Exceeded",
    },
    {
      sno: 4,
      branchName: "TUMTIKAWN",
      projectName: "construction of tumtikawn road work",
      estimationValue: "₹78,26,90,00.00",
      currentExpenses: "₹0.0000",
      status: "Normal",
    },
    {
      sno: 5,
      branchName: "Branch 8",
      projectName: "CBE to MTP Bach Work Part 2",
      estimationValue: "₹57,73.50",
      currentExpenses: "₹46,00.0000",
      status: "Normal",
    },
    {
      sno: 6,
      branchName: "Branch 8",
      projectName: "KOVAI TO HOPES",
      estimationValue: "₹65,96,175.00",
      currentExpenses: "₹0.0000",
      status: "Normal",
    },
    {
      sno: 7,
      branchName: "Branch 8",
      projectName: "D HIGHWAY CONSTRUCTION",
      estimationValue: "₹15,03,000.00",
      currentExpenses: "₹15.0000",
      status: "Normal",
    },
    {
      sno: 8,
      branchName: "Branch 8",
      projectName: "test",
      estimationValue: "₹1,74,455.00",
      currentExpenses: "₹1,72,799.2500",
      status: "Normal",
    },
    {
      sno: 9,
      branchName: "Branch 8",
      projectName: "ROAD LAYER",
      estimationValue: "₹17,500.00",
      currentExpenses: "₹0.0000",
      status: "Normal",
    },
    {
      sno: 10,
      branchName: "Branch 8",
      projectName: "Test Road Project 05-02-2022",
      estimationValue: "₹21,67,067.24",
      currentExpenses: "₹0.0000",
      status: "Normal",
    },
    {
      sno: 11,
      branchName: "H/O 1",
      projectName: "Building Project 07-02-2022",
      estimationValue: "₹9,01,343.95",
      currentExpenses: "₹0.0000",
      status: "Normal",
    },
    {
      sno: 12,
      branchName: "HILARA",
      projectName: "Project Work 12-02-2022",
      estimationValue: "₹23,29,7037.49",
      currentExpenses: "₹6,63,023.6000",
      status: "Normal",
    },
    {
      sno: 13,
      branchName: "HILARA",
      projectName: "HOUSING CONSTRUCTION",
      estimationValue: "₹2,90,000.00",
      currentExpenses: "₹2,90,000.0000",
      status: "Exceeded",
    },
    {
      sno: 14,
      branchName: "HILARA",
      projectName: "GRAND BRIDGE CONSTRUCTION",
      estimationValue: "₹8,25,000.00",
      currentExpenses: "₹8,24,890.0000",
      status: "Normal",
    },
    {
      sno: 15,
      branchName: "HILARA",
      projectName: "ROADING CONSTRUCT",
      estimationValue: "₹4,95,000.00",
      currentExpenses: "₹4,95,000.0000",
      status: "Exceeded",
    },
  ];

  // ==============================
  // Search filter
  // ==============================
  const filteredProjects = useMemo(() => {
    return projectAlerts.filter((item) => {
      const matchesSearch =
        item.projectName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.branchName.toLowerCase().includes(searchTerm.toLowerCase());

      const matchesFilter =
        activeFilter === "all" ||
        item.status.toLowerCase() === activeFilter.toLowerCase();

      return matchesSearch && matchesFilter;
    });
  }, [projectAlerts, searchTerm, activeFilter]);

  const getStatusIcon = (status) => {
    switch (status) {
      case "Normal":
        return <FaCheckCircle className="text-green-500" />;
      case "Exceeded":
        return <FaExclamationTriangle className="text-red-500" />;
      default:
        return <FaTimesCircle className="text-gray-500" />;
    }
  };

  const getStatusBadge = (status) => {
    const baseClasses =
      "px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1";
    switch (status) {
      case "Normal":
        return `${baseClasses} bg-green-100 text-green-800 border border-green-300`;
      case "Exceeded":
        return `${baseClasses} bg-red-100 text-red-800 border border-red-300`;
      default:
        return `${baseClasses} bg-gray-100 text-gray-800 border border-gray-300`;
    }
  };

  return (
    <LayoutWrapper>
      <div
        className={`min-h-screen transition-all duration-300 ${
          isDark
            ? "bg-gradient-to-br from-gray-900 via-gray-800 to-blue-900"
            : "bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50"
        }`}
      >
        {/* Header */}
        <div
          className={`sticky top-0 z-10 backdrop-blur-md border-b ${
            isDark
              ? "bg-gray-900/80 border-gray-700"
              : "bg-white/80 border-gray-200"
          }`}
        >
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <div>
                <h1
                  className={`text-3xl font-bold flex items-center gap-3 ${
                    isDark ? "text-white" : "text-gray-900"
                  }`}
                >
                  <FaProjectDiagram className="text-blue-500" />
                  PROJECT MANAGEMENT DASHBOARD ALERT
                </h1>
                <p
                  className={`text-sm mt-1 ${
                    isDark ? "text-gray-300" : "text-gray-600"
                  }`}
                >
                  Monitor and manage all project activities in real-time
                </p>

                {/* Optional localStorage info display */}
                <div
                  className={`mt-2 text-xs ${
                    isDark ? "text-gray-400" : "text-gray-500"
                  }`}
                >
                  Branch ID: {branchId || "-"} | User ID: {userId || "-"} | Fin
                  Year: {finYear || "-"}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="p-6 space-y-8">
          {/* Summary Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div
              className={`p-6 rounded-2xl shadow-xl border transition-all duration-300 hover:shadow-2xl hover:scale-105 ${
                isDark
                  ? "bg-gradient-to-br from-blue-900/50 to-blue-800/30 backdrop-blur-md border-blue-700 text-white"
                  : "bg-gradient-to-br from-blue-500 to-blue-600 text-white border-blue-300"
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-blue-100 text-sm font-medium">
                    Total Estimations
                  </p>
                  <p className="text-3xl font-bold">60</p>
                </div>
                <FaFileInvoiceDollar className="text-4xl text-blue-200" />
              </div>
            </div>

            <div
              className={`p-6 rounded-2xl shadow-xl border transition-all duration-300 hover:shadow-2xl hover:scale-105 ${
                isDark
                  ? "bg-gradient-to-br from-green-900/50 to-green-800/30 backdrop-blur-md border-green-700 text-white"
                  : "bg-gradient-to-br from-green-500 to-green-600 text-white border-green-300"
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-green-100 text-sm font-medium">
                    Total Tenders
                  </p>
                  <p className="text-3xl font-bold">29</p>
                </div>
                <FaHandshake className="text-4xl text-green-200" />
              </div>
            </div>

            <div
              className={`p-6 rounded-2xl shadow-xl border transition-all duration-300 hover:shadow-2xl hover:scale-105 ${
                isDark
                  ? "bg-gradient-to-br from-purple-900/50 to-purple-800/30 backdrop-blur-md border-purple-700 text-white"
                  : "bg-gradient-to-br from-purple-500 to-purple-600 text-white border-purple-300"
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-purple-100 text-sm font-medium">
                    Total Projects
                  </p>
                  <p className="text-3xl font-bold">15</p>
                </div>
                <FaProjectDiagram className="text-4xl text-purple-200" />
              </div>
            </div>

            <div
              className={`p-6 rounded-2xl shadow-xl border transition-all duration-300 hover:shadow-2xl hover:scale-105 ${
                isDark
                  ? "bg-gradient-to-br from-orange-900/50 to-orange-800/30 backdrop-blur-md border-orange-700 text-white"
                  : "bg-gradient-to-br from-orange-500 to-orange-600 text-white border-orange-300"
              }`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-orange-100 text-sm font-medium">
                    Success Rate
                  </p>
                  <p className="text-3xl font-bold">100%</p>
                </div>
                <FaChartLine className="text-4xl text-orange-200" />
              </div>
            </div>
          </div>

          {/* Estimation Alert Section */}
          <div
            className={`rounded-2xl shadow-2xl border overflow-hidden ${
              isDark
                ? "bg-gray-800/50 backdrop-blur-md border-gray-700"
                : "bg-white border-gray-200"
            }`}
          >
            <div
              className={`px-6 py-4 border-b flex items-center gap-3 ${
                isDark
                  ? "bg-blue-900/30 border-gray-700"
                  : "bg-blue-600 text-white border-blue-700"
              }`}
            >
              <FaFileInvoiceDollar className="text-2xl" />
              <h2 className="text-xl font-bold">ESTIMATION ALERT</h2>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead
                  className={`${
                    isDark ? "bg-gray-700 text-gray-200" : "bg-gray-50 text-gray-700"
                  }`}
                >
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      S.No
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Branch Name
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Total Estimation
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Waiting
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Approved
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Total Estimation Cost
                    </th>
                  </tr>
                </thead>
                <tbody
                  className={`${
                    isDark ? "bg-gray-800" : "bg-white"
                  } divide-y ${isDark ? "divide-gray-700" : "divide-gray-200"}`}
                >
                  {estimationAlerts.map((item, index) => (
                    <tr
                      key={index}
                      className={`hover:${
                        isDark ? "bg-gray-700" : "bg-blue-50"
                      } transition-colors duration-200`}
                    >
                      <td
                        className={`px-6 py-4 text-sm ${
                          isDark ? "text-gray-300" : "text-gray-900"
                        }`}
                      >
                        {item.sno}
                      </td>
                      <td
                        className={`px-6 py-4 text-sm font-medium ${
                          isDark ? "text-white" : "text-gray-900"
                        }`}
                      >
                        {item.branchName}
                      </td>
                      <td
                        className={`px-6 py-4 text-sm ${
                          isDark ? "text-blue-300" : "text-blue-600"
                        }`}
                      >
                        {item.totalEstimation}
                      </td>
                      <td
                        onClick={() =>
                          window.open(getReportPath("EstimationDashboardReport"), "_blank")
                        }
                        className={`px-6 py-4 text-sm cursor-pointer ${
                          isDark ? "text-orange-300" : "text-orange-600"
                        }`}
                      >
                        {item.waiting}
                      </td>
                      <td
                        onClick={() =>
                          window.open(getReportPath("EstimationApprovedReport"), "_blank")
                        }
                        className={`px-6 py-4 text-sm cursor-pointer ${
                          isDark ? "text-green-300" : "text-green-600"
                        }`}
                      >
                        {item.approved}
                      </td>
                      <td
                        className={`px-6 py-4 text-sm font-semibold ${
                          isDark ? "text-yellow-300" : "text-green-700"
                        }`}
                      >
                        {item.totalEstimationCost}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Tender Alert Section */}
          <div
            className={`rounded-2xl shadow-2xl border overflow-hidden ${
              isDark
                ? "bg-gray-800/50 backdrop-blur-md border-gray-700"
                : "bg-white border-gray-200"
            }`}
          >
            <div
              className={`px-6 py-4 border-b flex items-center gap-3 ${
                isDark
                  ? "bg-green-900/30 border-gray-700"
                  : "bg-green-600 text-white border-green-700"
              }`}
            >
              <FaHandshake className="text-2xl" />
              <h2 className="text-xl font-bold">TENDER ALERT</h2>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead
                  className={`${
                    isDark ? "bg-gray-700 text-gray-200" : "bg-gray-50 text-gray-700"
                  }`}
                >
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      S.No
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Branch Name
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Total Tenders
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Success
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      UnSuccess
                    </th>
                  </tr>
                </thead>
                <tbody
                  className={`${
                    isDark ? "bg-gray-800" : "bg-white"
                  } divide-y ${isDark ? "divide-gray-700" : "divide-gray-200"}`}
                >
                  {tenderAlerts.map((item, index) => (
                    <tr
                      key={index}
                      className={`hover:${
                        isDark ? "bg-gray-700" : "bg-green-50"
                      } transition-colors duration-200`}
                    >
                      <td
                        className={`px-6 py-4 text-sm ${
                          isDark ? "text-gray-300" : "text-gray-900"
                        }`}
                      >
                        {item.sno}
                      </td>
                      <td
                        className={`px-6 py-4 text-sm font-medium ${
                          isDark ? "text-white" : "text-gray-900"
                        }`}
                      >
                        {item.branchName}
                      </td>
                      <td
                        className={`px-6 py-4 text-sm ${
                          isDark ? "text-blue-300" : "text-blue-600"
                        }`}
                      >
                        {item.totalTenders}
                      </td>
                      <td
                        onClick={() =>
                          window.open(getReportPath("TenderSuccessfulReport"), "_blank")
                        }
                        className={`px-6 py-4 text-sm cursor-pointer ${
                          isDark ? "text-green-300" : "text-green-600"
                        }`}
                      >
                        {item.success}
                      </td>
                      <td
                        onClick={() =>
                          window.open(
                            getReportPath("TenderUnSussessfulReport"),
                            "_blank"
                          )
                        }
                        className={`px-6 py-4 text-sm cursor-pointer ${
                          isDark ? "text-red-300" : "text-red-600"
                        }`}
                      >
                        {item.unSuccess}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Project Alert Section */}
          <div
            className={`rounded-2xl shadow-2xl border overflow-hidden ${
              isDark
                ? "bg-gray-800/50 backdrop-blur-md border-gray-700"
                : "bg-white border-gray-200"
            }`}
          >
            <div
              className={`px-6 py-4 border-b flex items-center justify-between ${
                isDark
                  ? "bg-purple-900/30 border-gray-700"
                  : "bg-purple-600 text-white border-purple-700"
              }`}
            >
              <div className="flex items-center gap-3">
                <FaProjectDiagram className="text-2xl" />
                <h2 className="text-xl font-bold">PROJECT ALERT</h2>
              </div>

              <div className="flex items-center gap-2">
                <div className="relative">
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                  <input
                    type="text"
                    placeholder="Search projects..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pl-10 pr-4 py-2 rounded-lg text-sm bg-white/20 backdrop-blur-md border border-white/30 text-white placeholder-white/70 focus:outline-none focus:ring-2 focus:ring-white/50"
                  />
                </div>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead
                  className={`${
                    isDark ? "bg-gray-700 text-gray-200" : "bg-gray-50 text-gray-700"
                  }`}
                >
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      S.No
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Branch Name
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Project Name
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Estimation Value
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Current Expenses
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Status
                    </th>
                    <th className="px-6 py-4 text-left text-sm font-semibold">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody
                  className={`${
                    isDark ? "bg-gray-800" : "bg-white"
                  } divide-y ${isDark ? "divide-gray-700" : "divide-gray-200"}`}
                >
                  {filteredProjects.map((item, index) => (
                    <tr
                      key={index}
                      className={`hover:${
                        isDark ? "bg-gray-700" : "bg-purple-50"
                      } transition-colors duration-200`}
                    >
                      <td
                        className={`px-6 py-4 text-sm ${
                          isDark ? "text-gray-300" : "text-gray-900"
                        }`}
                      >
                        {item.sno}
                      </td>
                      <td
                        className={`px-6 py-4 text-sm font-medium ${
                          isDark ? "text-white" : "text-gray-900"
                        }`}
                      >
                        {item.branchName}
                      </td>
                      <td
                        className={`px-6 py-4 text-sm ${
                          isDark ? "text-blue-300" : "text-purple-700"
                        }`}
                      >
                        <div className="max-w-xs truncate" title={item.projectName}>
                          {item.projectName}
                        </div>
                      </td>
                      <td
                        className={`px-6 py-4 text-sm font-semibold ${
                          isDark ? "text-green-300" : "text-green-700"
                        }`}
                      >
                        {item.estimationValue}
                      </td>
                      <td
                        className={`px-6 py-4 text-sm ${
                          isDark ? "text-orange-300" : "text-orange-600"
                        }`}
                      >
                        {item.currentExpenses}
                      </td>
                      <td className="px-6 py-4">
                        <span className={getStatusBadge(item.status)}>
                          {getStatusIcon(item.status)}
                          {item.status}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() => window.open("/OrderManagement/BOQ", "_blank")}
                          className={`px-3 py-1 rounded-lg text-xs font-medium transition-all duration-200 hover:scale-105 ${
                            isDark
                              ? "bg-blue-600 hover:bg-blue-700 text-white"
                              : "bg-blue-100 hover:bg-blue-200 text-blue-700"
                          }`}
                        >
                          <FaEye className="inline mr-1" />
                          More Details
                        </button>
                      </td>
                    </tr>
                  ))}

                  {filteredProjects.length === 0 && (
                    <tr>
                      <td
                        colSpan="7"
                        className={`px-6 py-6 text-center text-sm ${
                          isDark ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        No projects found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </LayoutWrapper>
  );
};

export default ProjectManagementDashboard;